import React, { useState } from 'react';
import { Link } from 'react-router-dom';

import { useNavigate } from 'react-router-dom';

import './Navbar.css';


function Navbar() {
  const navigate = useNavigate();

  const [isNavCollapsed, setIsNavCollapsed] = useState(true);

  const handleNavCollapse = () => setIsNavCollapsed(!isNavCollapsed);

  const navigateToContact = () => {
  navigate("/");
  setTimeout(() => {
   const contactSection = document.getElementById("donation-section");
   if (contactSection) {
     contactSection.scrollIntoView({ behavior: "smooth" });
   }
  }, 100);
  } // Delay for smoother scroll
  return (
    <nav className="navbar navbar-expand-lg navbar-light sticky-top p-0" style={{zIndex:'1001'}}>
    <a className="navbar-brand d-flex align-items-center px-4 px-lg-5" href="/">
    <img src="/img/img/Blue_Planet_v122823.jpg" style={{height: '100%', width: '100%', objectFit: 'contain'}} />
    </a>
    <button type="button" className="navbar-toggler me-4" onClick={handleNavCollapse}>
      <span className="navbar-toggler-icon" />
    </button>
    <div className={`${isNavCollapsed ? 'collapse' : ''} navbar-collapse`} id="navbarCollapse">
    <div className="navbar-nav ms-auto p-4 p-lg-0">
        <Link className="nav-item nav-link" to="/">Home</Link>
        <Link className="nav-item nav-link" to="/site/about">About</Link>
        <Link className="nav-item nav-link" to="/site/program">Programs</Link>
        <Link className="nav-item nav-link" to="/site/locations">Locations</Link>
        <Link className="nav-item nav-link" to="/site/contact">Contact</Link>
        <Link className="nav-item nav-link" to="/site/signin">Login</Link>
        {/* <a className="nav-item nav-link active" href="http://planetecosystem.com/">Home</a>
        <a className="nav-item nav-link" href="http://planetecosystem.com/about.html">About</a>
        <a className="nav-item nav-link" href="http://planetecosystem.com/program.html">Programs</a>
        <a className="nav-item nav-link" href="http://planetecosystem.com/locations.html">Locations</a>
        <a className="nav-item nav-link" href="http://planetecosystem.com/contact.html">Contact</a> */}
        {/* <a class='nav-item nav-link' href='http://planetecosystem.com/blog.html'>Blog</a> */}
    </div>
    {/* <a href="" className="btn push-button btn-primary py-4 px-lg-4 rounded-0 d-none d-lg-block">
      Donate
        ❤️<i className="fa fa-arrow-right ms-3" />
    </a> */}
    <Link to='/site/donate' className="btn push-button btn-primary py-4 px-lg-4 rounded-0 d-none d-lg-block">
      Donate ❤️<i className="fa fa-arrow-right ms-3" />
    </Link>
    
    </div>
    </nav>
  );
}

export default Navbar;